import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingBag } from '@fortawesome/free-solid-svg-icons';

const BagIcon = () => {
  return (
    <FontAwesomeIcon className='mx-2' icon={faShoppingBag} />
  );
};

export default BagIcon;
